import './App.css';
import { ChartsDisplayLayout } from './components/ChartsDisplayLayout/ChartsDisplayLayout';

function App() {
  return (
      <div className="App">
        <ChartsDisplayLayout />
      </div>
  );
}

export default App;
